import * as Yup from 'yup';

const validateRequestorFieldArray = (fields: any) => {
  if (fields.length > 1) {
    let validationArray = fields[fields.length - 1];
    const isNullish = Object.values(validationArray).every((value) => {
      if (value === null) return true;
      return false;
    });
    if (fields.length > 1 && isNullish)
      return fields.slice(0, fields.length - 1);
    else return fields.slice(0, fields.length);
  }
};

export const validationFormSchema =
  //  Yup.array()
  //   .transform((fields) => validateRequestorFieldArray(fields))
  //   .of(
  Yup.object().shape({
    description: Yup.string().required('Required').nullable(),
    // importanceLevel: Yup.string().required('Resquired').nullable(),
  });
// );
